import { createFileRoute } from "@tanstack/react-router";
import {
    kennelListingDetailRoute,
    KennelListingPage,
} from "@/features/provider-home";

export const Route = createFileRoute("/kennel/_dashboard/listings/$listingId")({
    ssr: kennelListingDetailRoute.ssr,
    head: kennelListingDetailRoute.head,
    component: KennelListingPage,
});
